/**
 * 报名状态管理 (Zustand)
 */

import { create } from 'zustand';
import { FormData, RegistrationStatus, Registration } from '../types';

interface RegistrationState {
  /** 报名ID */
  registrationId: string | null;
  /** 报名状态 */
  status: RegistrationStatus | null;
  /** 表单数据 */
  formData: FormData | null;
  /** 完整报名信息 */
  registration: Registration | null;
  /** 是否正在加载 */
  isLoading: boolean;
  /** 错误信息 */
  error: string | null;
  
  /** 设置报名信息 */
  setRegistration: (registration: Registration) => void;
  /** 设置表单数据 */
  setFormData: (data: FormData) => void;
  /** 设置加载状态 */
  setLoading: (loading: boolean) => void;
  /** 设置错误 */
  setError: (error: string | null) => void;
  /** 清除状态 */
  clear: () => void;
}

export const useRegistrationStore = create<RegistrationState>((set) => ({
  registrationId: null,
  status: null,
  formData: null,
  registration: null,
  isLoading: false,
  error: null,
  
  setRegistration: (registration) =>
    set({
      registrationId: registration.id,
      status: registration.status,
      registration,
      error: null,
    }),
  
  setFormData: (data) => set({ formData: data }),
  
  setLoading: (isLoading) => set({ isLoading }),
  
  setError: (error) => set({ error, isLoading: false }),
  
  clear: () =>
    set({
      registrationId: null,
      status: null,
      formData: null,
      registration: null,
      isLoading: false,
      error: null,
    }),
}));
